import {TheRave} from "../TheRave";
import {Layers, TheRaveLayers} from "./TheRaveLayers";
import {TweenLite} from "gsap";
import {FontStyleConfig} from "../config/FontConfig";
import {BitmapCountUp} from "../coutup/BitmapCountUp";
import {TheRaveReelView} from "../reels/TheRaveReelView";

export class Ways extends PIXI.Container {

    private readonly waysHolderPos: number[][] = [[-77, 155], [648, 0]];
    private _staticWaysPortrait: PIXI.Sprite;
    private _waysCountUp: BitmapCountUp;
    private _numberGlowText: PIXI.BitmapText;

    private readonly _defaultReelValue: number[] = [3, 3, 3, 3, 3];
    private _currentReelValue: number[] = [3, 3, 3, 3, 3];

    public get currentValue(): number {
        return TheRave.model.totalWays;
    }

    constructor() {
        super();

        this._staticWaysPortrait = new PIXI.Sprite(TheRave.assetLoader.getTextures("backgroundAssets/ways")[0]);
        this._staticWaysPortrait.anchor.set(0.5, 0.5);
        this._staticWaysPortrait.y = 18;
        this.addChild(this._staticWaysPortrait);

        this._numberGlowText = new PIXI.BitmapText(this.currentValue.toString(), FontStyleConfig.WAYS_GLOW);
        (<PIXI.Point>this._numberGlowText.anchor).set(0.5, 1);
        this._numberGlowText.scale.set(0.4);
        this._numberGlowText.y = -18;
        this._numberGlowText.letterSpacing = -8;
        this._numberGlowText.visible = false;
        this.addChild(this._numberGlowText);

        this._waysCountUp = this.addChild(new BitmapCountUp(FontStyleConfig.WAYS_NORMAL, {precision: 0}));
        this._waysCountUp.anchor = 0.5;
        this._waysCountUp.position.x = 0;
        this._waysCountUp.position.y = 8;
        this._waysCountUp.getCountUpAnimation(this.currentValue, this.currentValue, {duration: 0, withoutSound:true});

        this.position.set(648, TheRaveReelView.REEL_TOP-this._staticWaysPortrait.height*0.5-32);
        TheRaveLayers.getLayer(Layers.REEL_FRAME)?.addChild(this);
        this.onOrientationChanged();
    }

    private updateWaysDisplay(animate: boolean): void {
        const value = this._waysCountUp.currentValue;
        if (value === this.currentValue) {
            return;
        }
        this._waysCountUp.getCountUpAnimation(value, this.currentValue, {duration: 0.3, ease: `power3.out`, withoutSound:true});
        this._numberGlowText.text = this.currentValue.toString();

        if (animate) {
            if (this._waysCountUp.visible) {
                TweenLite.fromTo(this._waysCountUp.scale, {x: 1.3, y: 1.3}, {x: 1, y: 1, duration: 0.4});
            }
            if (this._numberGlowText.visible) {
                TweenLite.fromTo(this._numberGlowText.scale, {x: 0.52, y: 0.52}, {x: 0.4, y: 0.4, duration: 0.4});
            }
        }
    }

    public reset(): void {
        const ways: number = (this._defaultReelValue.reduce((a, b) => {
            return a * b;
        }));
        this._waysCountUp.getCountUpAnimation(this._waysCountUp.currentValue, ways, {duration: 0.3, withoutSound:true});
        this._numberGlowText.text = ways.toString();
    }

    public reelSplit(reelId: number): void {
        this._currentReelValue[reelId] *= 2;
        this.updateWaysDisplay(true);
    }

    public xSplit(): void {
        this._currentReelValue[0] *= 2;
        this._currentReelValue[1] = this.getReelWays(1);
        this._currentReelValue[2] = this.getReelWays(2);
        this._currentReelValue[3] = this.getReelWays(3);
        this.updateWaysDisplay(true);
    }

    public xWays(): void {
        this.updateWaysDisplay(true);
    }

    public onRestore(): void {

        this._waysCountUp.getCountUpAnimation(0, this.currentValue, {duration: 0.3, ease: `power3.out`, withoutSound:true});
        this._numberGlowText.text = this.currentValue.toString();
    }

    private getReelWays(reelId: number): number {
        let sum = 0;
        for (let symId = 0; symId < 3; symId++) {
            sum += TheRave.reels[reelId].getSymbol(symId, false, false).symbolSize;
        }
        return sum;
    }

    public onModeChange() {
        this.position.set(644, TheRaveReelView.REEL_TOP-this._staticWaysPortrait.height*0.5-32);
    }

    public onOrientationChanged() {
        //const isLandscape: boolean = NolimitApplication.isLandscape;
        //const pos: number[] = this.waysHolderPos[isLandscape ? 0 : 1];
        //this.position.set(pos[0], pos[1]);
    }

    public setColor(color: number, isSuper: boolean): void {
        this._waysCountUp.tint = color;
        this._staticWaysPortrait.tint = color;
        this._staticWaysPortrait.texture = TheRave.assetLoader.getTextures(`ways${isSuper ? "_super" : ""}`)[0];
        this._numberGlowText.visible = isSuper;
        this._waysCountUp.visible = !this._numberGlowText.visible;
    }
}